<header [class.sticky]="isSticky">
  <nav class="navbar gap-2 navbar-expand-xl justify-content-center">
    <div class="container">
      <div>
        <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbar-content" aria-controls="navbar-content" aria-expanded="false"
          aria-label="Toggle navigation">
          <app-icon name="bars"></app-icon>
        </button>
        <a class="navbar-brand" routerLink="/" *ngIf="!schoolBrand"><img
            [src]="'cdn/ghrus-logo.webp' | cdnImage"
            alt="Logo | GHRU Saikheda" width="400" height="126" /></a>
        <a class="school-brand school-logo" *ngIf="schoolBrand" routerLink="/" aria-label="GHRU main home">
          <img [src]="schoolBrand.logo" [alt]="schoolBrand.name + ' logo'" />
        </a>
      </div>

      <app-academic-navigation></app-academic-navigation>

      <div class="main-navbar collapse navbar-collapse" id="navbar-content">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown" routerLinkActive #aboutActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="aboutActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              About
            </a>
            <ul class="dropdown-menu fade-down">
              <li>
                <a class="dropdown-item" routerLink="/about/about-raisoni" routerLinkActive="active"
                  (click)="closeNavbar()">About Raisoni Group</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/about-ghru" routerLinkActive="active"
                  (click)="closeNavbar()">About GHRU</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/vision-mission" routerLinkActive="active"
                  (click)="closeNavbar()">Vision and Mission</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/leadership" routerLinkActive="active"
                  (click)="closeNavbar()">Leadership</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/governance" routerLinkActive="active"
                  (click)="closeNavbar()">Governance</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/recognition-accreditation" routerLinkActive="active"
                  (click)="closeNavbar()">Recognition &amp; Accreditation</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/mous" routerLinkActive="active"
                  (click)="closeNavbar()">MOUs</a>
              </li>
              <li>
                <a class="dropdown-item"
                  href="https://ghrus.s3.ap-south-1.amazonaws.com/ghrusaikheda/pdf/UGC-e-samadhan-letter.pdf"
                  target="_blank" (click)="closeNavbar()">
                  UGC e-samadhan
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/about/social-initiatives" routerLinkActive="active"
                  (click)="closeNavbar()">Social Initiatives</a>
              </li>
            </ul>
          </li>
          <!-- <li class="nav-item dropdown" routerLinkActive #programsActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="programsActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              Programs </a>
            <ul class="dropdown-menu fade-down">

            </ul>
          </li> -->
          <li class="nav-item dropdown" routerLinkActive #schoolsActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="schoolsActive.isActive"
              href="Javascript:void(0);" data-bs-toggle="dropdown">
              School
            </a>
            <ul class="dropdown-menu fade-down">
              <li *ngFor="let school of schools">
                <a class="dropdown-item" [routerLink]="school.path"
                  routerLinkActive="active" (click)="closeNavbar()">
                  {{ school.name }}
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" routerLinkActive #admissionActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="admissionActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              Admission
            </a>
            <ul class="dropdown-menu fade-down">
              <li>
                <a class="dropdown-item" routerLink="/admission/dean-admission" routerLinkActive="active"
                  (click)="closeNavbar()">Message From Dean Admissions
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admission/admission-procedure" routerLinkActive="active"
                  (click)="closeNavbar()">Admission Procedure
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admission/paytm-payment" routerLinkActive="active"
                  (click)="closeNavbar()">Important QR
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admission/education-loan" routerLinkActive="active"
                  (click)="closeNavbar()">Education Loan
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admission/rucet-2025" routerLinkActive="active"
                  (click)="closeNavbar()">RUCET 2025
                </a>
              </li>

              <!-- <li>
                <a class="dropdown-item" routerLink="/admission/bank-details" routerLinkActive="active"
                  (click)="closeNavbar()">Bank Details
                </a>
              </li> -->
            </ul>
          </li>
          <li class="nav-item dropdown dropdown-mega" routerLinkActive
            #academicsActive="routerLinkActive" [routerLinkActiveOptions]="{ exact: false }">
            <button type="button" class="nav-link dropdown-toggle" [class.nav-active]="academicsActive.isActive"
              data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">Academics & Research
            </button>
            <div class="dropdown-menu">
              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-lg-4">
                    <div class="col">
                      <h6>Academics</h6>
                      <ul>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/get-oriented" routerLinkActive="active"
                            (click)="closeNavbar()">Get Oriented</a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/examination" routerLinkActive="active"
                            (click)="closeNavbar()">Examination</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/academic-centers" routerLinkActive="active"
                            (click)="closeNavbar()">Academic Centers</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/add-on-courses" routerLinkActive="active"
                            (click)="closeNavbar()">Add On Courses</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/ccll" routerLinkActive="active"
                            (click)="closeNavbar()">Centre for Continuous and Lifelong Learning
                            (CCLL)</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/iqac" routerLinkActive="active"
                            (click)="closeNavbar()">IQAC</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/academic-calender" routerLinkActive="active"
                            (click)="closeNavbar()">Academic Calender
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="col">
                      <h6>Research & Development Cell</h6>
                      <ul>
                        <!-- <li>
                          <a
                            class="dropdown-item"
                            href="research-vision-mission"
                            (click)="closeNavbar()"
                            >Vision Mission</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="research-objectives"
                            (click)="closeNavbar()"
                            >Objectives of R&D cell</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="reaserch-function"
                            (click)="closeNavbar()"
                            >Function of R&D Cell at GHRUS</a
                          >
                        </li> -->
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-development-cell" routerLinkActive="active"
                            (click)="closeNavbar()">R&amp;D Cell</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-academic" routerLinkActive="active"
                            (click)="closeNavbar()">Academic Research</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-grant-management" routerLinkActive="active"
                            (click)="closeNavbar()">Research Grant Management</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-infra-management" routerLinkActive="active"
                            (click)="closeNavbar()">Research Infra Management</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-scholars-management" routerLinkActive="active"
                            (click)="closeNavbar()">Research Scholars Management</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/sponsored-research" routerLinkActive="active"
                            (click)="closeNavbar()">Sponsored Research</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/academics-and-research/research-grant" routerLinkActive="active"
                            (click)="closeNavbar()">Research Grant</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col">
                      <h6>Innovation</h6>
                      <ul>
                        <li>
                          <a class="dropdown-item" routerLink="/innovation/iic" routerLinkActive="active"
                            (click)="closeNavbar()">IIC</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/innovation/teaching-learning" routerLinkActive="active"
                            (click)="closeNavbar()">Teaching & Learning</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/innovation/industry-immersion" routerLinkActive="active"
                            (click)="closeNavbar()">Industry Immersion</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/innovation/msme" routerLinkActive="active" (click)="closeNavbar()">MSME</a>
                        </li>
                        <li>
                          <a class="dropdown-item" routerLink="/innovation/nisp" routerLinkActive="active"
                            (click)="closeNavbar()">NISP</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col">
                      <h6>Training Placement</h6>
                      <ul>
                        <li>
                          <a class="dropdown-item" routerLink="/training-placement" routerLinkActive="active"
                            (click)="closeNavbar()">Training Placement
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown" routerLinkActive #campusLifeActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="campusLifeActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              Campus Life
            </a>
            <ul class="dropdown-menu fade-down">
              <li>
                <a class="dropdown-item" routerLink="/campus-life/sports" routerLinkActive="active"
                  (click)="closeNavbar()">Sports</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/library" routerLinkActive="active"
                  (click)="closeNavbar()">Library</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/labs" routerLinkActive="active"
                  (click)="closeNavbar()">Labs</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/hostel" routerLinkActive="active"
                  (click)="closeNavbar()">Hostel</a>
              </li>

              <li>
                <a class="dropdown-item" routerLink="/campus-life/e-learning" routerLinkActive="active"
                  (click)="closeNavbar()">E-Learning</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/students-club" routerLinkActive="active"
                  (click)="closeNavbar()">Students Club</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/saarthi-counseling-center" routerLinkActive="active"
                  (click)="closeNavbar()">Saarthi Counseling Center</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/other-amenities" routerLinkActive="active"
                  (click)="closeNavbar()">Other Amenities</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/campus-life/facilities-differently-abled"
                  routerLinkActive="active" (click)="closeNavbar()">Facilities </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/events" routerLinkActive="active" [class.nav-active]="isEventPage"
              (click)="closeNavbar()">Events</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://currentopenings.raisoni.net/" target="_blank"
              (click)="closeNavbar()">Current Openings</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeNavbar()">Contact</a>
          </li>
          <li class="nav-item dropdown" routerLinkActive #moreActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle" [class.nav-active]="moreActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown" aria-label="More links">
              <app-icon name="bars"></app-icon>
            </a>
            <ul class="dropdown-menu end-menu fade-down">
              <li>
                <a class="dropdown-item"
                  href="https://ghrus.s3.ap-south-1.amazonaws.com/ghrusaikheda/pdf/ghru_tender_design_%26_development_of_incubation_centre.pdf"
                  target="_blank" rel="noopener noreferrer" (click)="closeNavbar()">Tender
                </a>
              </li>
              <li>
                <a class="dropdown-item"
                  href="https://ghrus.s3.ap-south-1.amazonaws.com/ghrusaikheda/pdf/corrigendum-I.pdf" target="_blank"
                  rel="noopener noreferrer" (click)="closeNavbar()">Corrigendum</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/humberger-menu/ncc" routerLinkActive="active"
                  (click)="closeNavbar()">NCC</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/blogs" routerLinkActive="active"
                  (click)="closeNavbar()">Blogs</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
